import axios from 'axios';
import qs from 'qs';

const api = axios.create({
  baseURL: `${process.env.ESBUILD_API_HOST}/api/v2/`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${qs.parse(document.location.search, { ignoreQueryPrefix: true }).token}`,
  },
  paramsSerializer(params) {
    return qs.stringify(params);
  },
});

export default api;
